export function initTables() {
    document.querySelectorAll('table.kdx-table').forEach((table: HTMLTableElement) => {
        if (table.hasAttribute('data-is-bound'))
          return;
        table.toggleAttribute('data-is-bound', true);

        // iterate through the table rows, duplicating them (skip key cell or first item)
        for (const body of table.tBodies)
        for (const row of body.rows) {
            const hiddenTable = document.createElement('table');
            hiddenTable.classList.add('collapse');

            row.after(hiddenTable);

            for (const cell of row.cells) {
                if (cell.cellIndex === 0) {
                    const open = document.createElement('kdx-icon');
                    open.setAttribute('icon', 'plus-circle');

                    const close = document.createElement('kdx-icon');
                    close.setAttribute('icon', 'minus-circle');

                    const span = document.createElement('span');
                    span.append(...cell.childNodes);

                    const toggleButton = document.createElement('a');
                    toggleButton.classList.add('btn-show-table-data');
                    toggleButton.append(open, close, span);

                    toggleButton.addEventListener('click', event => {
                        event.preventDefault();

                        const shouldOpen = !row.classList.contains('show');

                        body.querySelectorAll('.show').forEach(open => {
                            open.classList.remove('show');
                        });

                        row.classList.toggle('show', shouldOpen);
                        hiddenTable.classList.toggle('show', shouldOpen);
                    });

                    cell.append(toggleButton);
                }
                else {
                  hiddenTable.insertRow().append(
                    table.tHead.rows[0].cells[cell.cellIndex].cloneNode(true),
                    cell.cloneNode(true)
                  );
                }
            }
        }
    });
}
